import { createGlobalStyle, css } from 'styled-components';
import { STATIC_RESOURCES_BASE_URL } from 'utils/constants';

const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Maison Neue';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url('${STATIC_RESOURCES_BASE_URL}/fonts/MaisonNeueExt-Light.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  @font-face {
    font-family: 'Maison Neue';
    font-style: medium;
    font-weight: 400;
    font-display: swap;
    src: url('${STATIC_RESOURCES_BASE_URL}/fonts/MaisonNeueExt-Medium.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  @font-face {
    font-family: 'Maison Neue';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('${STATIC_RESOURCES_BASE_URL}/fonts/MaisonNeueExt-Bold.ttf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }


  @font-face {
    font-family: 'Adobe Caslon';
    font-style: italic;
    font-weight: 400;
    font-display: swap;
    src: url('${STATIC_RESOURCES_BASE_URL}/fonts/ACaslonPro-Italic.otf'); /* Chrome 26+, Opera 23+, Firefox 39+ */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .data-react-modal-body-trap {
    z-index: 9999;
  }

  .ReactModalPortal > div {
    z-index: 9998;
  }

  html, body, #__next {
    height: 100%;
  }

  html {
    font-size: 65%;
  }

  ${({ theme }) => css`
    body {
      font-family: ${theme.font.family};
      font-size: ${theme.font.sizes.medium};
    }
  `}
`;

export default GlobalStyles;
